<template>
  <div class="b2c_img" @click="onClick">
    <img
      v-if="lazyLoad"
      ref="img"
      v-lazy="src"
      :alt="alt"
      :style="{ objectFit: fit, borderRadius: radio }"
      @load="onLoad"
      @error="onError"
    />
    <img
      v-else
      ref="img"
      :src="src"
      :alt="alt"
      :style="{ objectFit: fit, borderRadius: radio }"
      @load="onLoad"
      @error="onError"
    />
    <div v-if="loading" class="b2c_img-loading"></div>
    <div v-if="error" class="b2c_img_error"></div>
  </div>
</template>

<script>
import { defineComponent, ref } from '@vue/composition-api'
export default defineComponent({
  props: {
    src: {
      type: String,
      default: ''
    },
    fit: {
      type: String,
      default: 'contain'
    },
    alt: {
      type: String,
      default: ''
    },
    lazyLoad: Boolean,
    radio: {
      type: String,
      default: '0'
    }
  },
  setup(props, ctx) {
    const loading = ref(true)
    const error = ref(false)
    const img = ref(null)
    const onClick = (event) => {
      ctx.emit('load', event, img.value.src)
    }
    const onLoad = () => {
      loading.value = false
      error.value = false
    }
    const onError = () => {
      error.value = true
    }
    return {
      onClick,
      onLoad,
      onError,
      loading,
      error,
      img
    }
  }
})
</script>

<style scoped lang="scss">
.b2c_img {
  position: relative;
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
  }
  &-loading,
  &-error {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(to top left, #f8f8f8, #f9f9f9);
  }
}
</style>
